import { createContext, useContext } from "react";
import type { StringSystem } from "../types/viewmodel";

export const ConfiguratorStringsContext = createContext<StringSystem | null>(null);

export function useStrings(): StringSystem {
	const strings = useContext(ConfiguratorStringsContext);
	if (!strings) {
		throw new Error("useStrings must be used within a ConfiguratorStringsContext.Provider");
	}
	return strings;
}